import { render, staticRenderFns } from "./answerVolumeHaibao.vue?vue&type=template&id=f07398f2&scoped=true&"
import script from "./answerVolumeHaibao.vue?vue&type=script&lang=js&"
export * from "./answerVolumeHaibao.vue?vue&type=script&lang=js&"
import style0 from "./answerVolumeHaibao.vue?vue&type=style&index=0&id=f07398f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07398f2",
  null
  
)

export default component.exports